import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/slices/authSlice';

const navItems = [
  { path: '/', icon: 'bi-grid', label: 'Dashboard' },
  { path: '/companies', icon: 'bi-building', label: 'Companies' },
  { path: '/conversations', icon: 'bi-chat-dots', label: 'Conversations' },
  { path: '/leads', icon: 'bi-people', label: 'Leads' },
  { path: '/knowledge', icon: 'bi-book', label: 'Knowledge' },
  { path: '/analytics', icon: 'bi-bar-chart', label: 'Analytics' },
  { path: '/users', icon: 'bi-person-badge', label: 'Users' },
  { path: '/settings', icon: 'bi-gear', label: 'Settings' },
  { path: '/admins', icon: 'bi-shield', label: 'Admins' },
];

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <NavLink to="/" className="sidebar-brand">
          <i className="bi bi-headset me-2"></i>AI Voice Admin
        </NavLink>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <i className={`bi ${item.icon}`}></i>
            <span>{item.label}</span>
          </NavLink>
        ))}
        <hr style={{ borderColor: 'var(--border)', margin: '1rem 1.5rem' }} />
        <button
          onClick={handleLogout}
          className="sidebar-link"
          style={{ background: 'none', border: 'none', width: '100%', cursor: 'pointer' }}
        >
          <i className="bi bi-box-arrow-left"></i>
          <span>Logout</span>
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;
